import React, { useEffect, useState } from "react";
import { TextField, MenuItem } from "@mui/material";
import axios from "axios";

/**
 * Selector de Estado genérico
 * - Busca la lista de estados en varios endpoints habituales.
 * - Envía value numérico (o "" si vacío) compatible con Formik handleChange.
 */
export default function SelectEstado({
    label = "Estado",
    name = "estadoId",
    value,
    onChange,
    allowEmpty = true,
    fullWidth = true,
    helperText,
    error,
    size,
}) {
    const [items, setItems] = useState([]);
    const API = process.env.REACT_APP_API_URL;
    const token = localStorage.getItem("token");

    useEffect(() => {
        let alive = true;
        (async () => {
            const headers = token ? { Authorization: `Bearer ${token}` } : {};
            const urls = [
                `${API}/api/estados`,
                `${API}/estados`,
                `${API}/catalogos/estados`,
                `${API}/api/catalogos/estados`,
            ];
            for (const url of urls) {
                try {
                    const { data } = await axios.get(url, { headers });
                    if (Array.isArray(data)) {
                        if (alive) setItems(data);
                        break;
                    }
                } catch {
                    // sigue probando siguiente URL
                }
            }
        })();
        return () => {
            alive = false;
        };
    }, [API, token]);

    const handleChange = (e) => {
        const raw = e.target.value;
        // Enviar número para backend (o "" si vacío), manteniendo compat con Formik
        onChange?.({
            target: { name, value: raw === "" ? "" : Number(raw) },
        });
    };

    return (
        <TextField
            select
            label={label}
            name={name}
            value={value ?? ""}
            onChange={handleChange}
            fullWidth={fullWidth}
            error={error}
            helperText={helperText}
            size={size}
        >
            {allowEmpty && <MenuItem value="">(Sin filtro)</MenuItem>}
            {items.map((it) => (
                <MenuItem key={it.id} value={it.id}>
                    {it.nombre ?? it.name ?? `Estado ${it.id}`}
                </MenuItem>
            ))}
        </TextField>
    );
}
